import { render, staticRenderFns } from "./GerenciarUnidadesOrcamentaria.vue?vue&type=template&id=19e5f4de&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarUnidadesOrcamentaria.vue?vue&type=style&index=0&id=19e5f4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e5f4de",
  null
  
)

export default component.exports